module.exports = __webpack_public_path__ + "static/media/main idea.71a5e0c0.mp3";